// App shell: landing page (T22) with the checker built in.
import './app.css';
import { ImportFlow } from './import/ImportFlow';
import { Faq, Hero, HowItWorks, Privacy, WhatItChecks } from './landing/Landing';
import { Disclaimer } from './report/Disclaimer';

export function App() {
  return (
    <>
      <a class="skip-link" href="#check">
        Skip to the rota checker
      </a>
      <header class="site-header">
        <a href="/" class="brand">
          <span class="brand-mark" aria-hidden="true" />
          ShiftLens
        </a>
        <nav aria-label="Main">
          <a href="#check">Check a rota</a>
          <a href="/explainer">The rules explained</a>
          <a href="/guides">Guides</a>
        </nav>
      </header>
      <main>
        <div class="no-print">
          <Hero />
        </div>
        <section id="check" aria-label="Rota checker" class="checker">
          <ImportFlow />
        </section>
        <div class="no-print landing-sections">
          <HowItWorks />
          <WhatItChecks />
          <Privacy />
          <Faq />
          <Disclaimer />
        </div>
      </main>
      <footer class="site-footer">
        <nav aria-label="Footer">
          <a href="/privacy">Privacy notice</a>
          <a href="/explainer">The rules explained</a>
          <a href="/guides">Guides</a>
          <a href="/supported-rotas">Rota template</a>
        </nav>
      </footer>
    </>
  );
}
